<template>
  <div class="main">
    <!--左侧 选择框-->
    <div class="left-bar">
      <!--无畏契约选择卡片-->
      <el-card class="box-card" :body-style="{ padding: '5px' }" v-if="$store.state.currentPage === 'val'">
        <!--无畏契约的选择卡片-->
        <div class="map-agent">
          <!--选择地图-->
          <div class="select-map" @click="showMapOptions">
            <img :src="config.game.val.maps[userSelect.val.map].imgSrc" alt="">

            <div class="select-map-title">
              <div>
                {{ config.game.val.maps[userSelect.val.map].title }}
              </div>
              <div>
                {{ config.game.val.maps[userSelect.val.map].chTitle }}
              </div>
            </div>
          </div>
          <!--选择特工-->
          <div class="select-agent" @click="showAgentOptions"
               :style="config.game.val.agents[userSelect.val.agent].background">
            <img :src="config.game.val.agents[userSelect.val.agent].imgSrc" alt="">
            <div class="agent-title">{{ config.game.val.agents[userSelect.val.agent].chTitle }}</div>
          </div>
        </div>
        <!--技能-->
        <el-divider content-position="left">技能</el-divider>
        <div class="ability-options">
          <template v-for="(value, name, index) in config.game.val.agents[userSelect.val.agent].ability">
            <template
                v-if="mapToAgent[userSelect.val.map] && mapToAgent[userSelect.val.map][userSelect.val.agent] && mapToAgent[userSelect.val.map][userSelect.val.agent][name]">
              <el-badge :value="mapToAgent[userSelect.val.map][userSelect.val.agent][name]" class="item"
                        :key="index">
                <div class="ability-item" @click="clickAbilityOption(name)">
                  <img :src="value.imgSrc" alt="" v-bind:class="{'img-opacity2': userSelect.val.ability!=name}">
                </div>
              </el-badge>
            </template>
            <template v-else>
              <div class="ability-item" @click="clickAbilityOption(name)" :key="index">
                <img :src="value.imgSrc" alt="" v-bind:class="{'img-opacity2': userSelect.val.ability!=name}">
              </div>
            </template>
          </template>
        </div>
        <el-divider content-position="left">进攻/防守</el-divider>
        <div class="radio-buttons">
          <div class="radio-item" @click="clickSideOption(0)">
            <input type="radio" id="red" name="color" :value="0" :checked="userSelect.val.side===0">
            <label for="red">
              全部
            </label>
          </div>
          <div class="radio-item" @click="clickSideOption(1)">
            <input type="radio" id="blue" name="color" :value="1" :checked="userSelect.val.side===1">
            <label for="blue">
              进攻
            </label>
          </div>
          <div class="radio-item" @click="clickSideOption(2)">
            <input type="radio" id="green" name="color" :value="2" :checked="userSelect.val.side===2">
            <label for="green">
              防守
            </label>
          </div>
        </div>
      </el-card>
      <!--CS2选择卡片-->
      <el-card class="box-card" :body-style="{ padding: '5px' }" v-if="$store.state.currentPage === 'cs2'">
        <div class="cs2-map-agent">
          <!--选择地图-->
          <div class="select-map" @click="showCS2MapOptions">
            <img :src="config.game.cs2.maps[userSelect.cs2.map].imgSrc" alt="">

            <div class="select-map-title">
              <div>
                {{ config.game.cs2.maps[userSelect.cs2.map].title }}
              </div>
              <div>
                {{ config.game.cs2.maps[userSelect.cs2.map].chTitle }}
              </div>
            </div>
          </div>
        </div>
        <!--道具选项-->
        <el-divider content-position="left">道具</el-divider>
        <div class="ability-options">
          <template v-for="(value, name, index) in config.game.cs2.ability">
            <template v-if="cs2MapToAbility[userSelect.cs2.map] && cs2MapToAbility[userSelect.cs2.map][name]">
              <el-badge :value="cs2MapToAbility[userSelect.cs2.map][name]" class="item"
                        :key="index">
                <div :key="index" class="ability-item" @click="clickCS2AbilityOption(name)">
                  <img :src="value.imgSrc" v-bind:class="{'img-opacity2': userSelect.cs2.ability!=name}">
                </div>
              </el-badge>
            </template>
            <template v-else>
              <div :key="index" class="ability-item" @click="clickCS2AbilityOption(name)">
                <img :src="value.imgSrc" v-bind:class="{'img-opacity2': userSelect.cs2.ability!=name}">
              </div>
            </template>

          </template>
        </div>
        <el-divider content-position="left">T/CT</el-divider>
        <div class="cs2-radio-buttons">
          <div class="radio-item" @click="changeCS2SideOptions(0)">
            <input type="radio" id="red" name="color" :value="0" :checked="userSelect.cs2.side===0">
            <label for="red">
              <img class="radio-icon icon-red" :src="config.game.cs2.side[0].imgSrc">
              全部
            </label>
          </div>
          <div class="radio-item" @click="changeCS2SideOptions(1)">
            <input type="radio" id="blue" name="color" :value="1" :checked="userSelect.cs2.side===1">
            <label for="blue">
              <img class="radio-icon icon-red" :src="config.game.cs2.side[1].imgSrc">
              T
            </label>
          </div>
          <div class="radio-item" @click="changeCS2SideOptions(2)">
            <input type="radio" id="green" name="color" :value="2" :checked="userSelect.cs2.side===2">
            <label for="green">
              <img class="radio-icon icon-red" :src="config.game.cs2.side[2].imgSrc">
              CT
            </label>
          </div>
        </div>
      </el-card>
      <!--三角洲选择卡片-->
      <el-card class="box-card" :body-style="{ padding: '5px' }" v-if="$store.state.currentPage === 'df'">
        <div class="map-agent">
          <!--选择地图-->
          <div class="select-map" @click="showDFMapOptions">
            <img :src="config.game.df.maps[userSelect.df.map].imgSrc" alt="">

            <div class="select-map-title">
              <!--              <div>-->
              <!--                {{ config.game.df.maps[userSelect.df.map].title }}-->
              <!--              </div>-->
              <div>
                {{ config.game.df.maps[userSelect.df.map].chTitle }}
              </div>
            </div>
          </div>
          <!--选择英雄-->
          <div class="select-agent" @click="showDFAgentOptions">
            <img :src="config.game.df.agents[userSelect.df.agent].imgSrc" alt="">
            <div class="agent-title">{{ config.game.df.agents[userSelect.df.agent].chTitle }}</div>
          </div>
        </div>
      </el-card>
      <!--添加lineup-->
      <el-card class="box-card" style="margin-top: 20px" v-if="$store.state.userinfo.isAdmin">
        <div slot="header" class="clearfix">
          <span style="font-weight: 600">添加LINEUP</span>
        </div>
        <el-row>
          <el-col :span="4">ID</el-col>
          <el-col :span="18">
            <el-input size="mini" v-model="lineupForm.blogId"></el-input>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px">
          <el-col :span="4">标题</el-col>
          <el-col :span="18">
            <el-input size="mini" v-model="lineupForm.title"></el-input>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px">
          <el-col :span="4">站点</el-col>
          <el-col :span="10">
            <el-input :disabled="true" size="mini" v-model="lineupForm.startPoint"></el-input>
          </el-col>
          <el-col :span="10">
            <el-button type="primary" size="mini" @click="selectPoint('start')">地图选点</el-button>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px">
          <el-col :span="4">落点</el-col>
          <el-col :span="10">
            <el-input :disabled="true" size="mini" v-model="lineupForm.endPoint"></el-input>
          </el-col>
          <el-col :span="10">
            <el-button type="primary" size="mini" @click="selectPoint('end')">地图选点</el-button>
          </el-col>
        </el-row>
        <!--创建一个范围-->
        <el-row style="margin-top: 10px">
          <el-col :span="4">范围</el-col>
          <el-col :span="10">
            <template v-if="lineupForm.isTempPolygon">
              <el-button type="success" size="mini" @click="selectRangeDone">创建完成</el-button>
            </template>
            <template v-else>
              <el-button type="primary" size="mini" @click="selectRange">创建范围</el-button>
            </template>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px">
          <template v-for="(item, index) in lineupForm.polygonList">
            <el-tag :key="index" style="margin: 5px" closable size="mini" @close="handleClosePolygon(index)">{{
                item[0]
              }}
            </el-tag>
          </template>
        </el-row>
        <!--创建直接显示的折线-->
        <el-row style="margin-top: 10px">
          <el-col :span="10">直接显示的折线</el-col>
          <el-col :span="10">
            <template v-if="lineupForm.isTempPolylineWithEndPoint">
              <el-button type="success" size="mini" @click="selectPolylineWithEndPointDone">创建完成</el-button>
            </template>
            <template v-else>
              <el-button type="primary" size="mini" @click="selectPolylineWithEndPoint">创建折线</el-button>
            </template>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px">
          <template v-if="lineupForm.polylineWithEndPointList.length!==0">
            <el-tag style="margin: 5px" closable size="mini" @close="handleClosePolylineWithEndPoint">{{
                lineupForm.polylineWithEndPointList[0]
              }}
            </el-tag>
          </template>
        </el-row>
        <el-divider></el-divider>
        <el-row style="margin-top: 10px">
          <el-button type="primary" size="mini" @click="submitLineup">提交</el-button>
        </el-row>
      </el-card>
    </div>
    <!--中间 地图主体-->
    <div class="mid-bar">
      <div id="map" ref="map"
           :style="{ backgroundColor: $store.state.currentPage === 'val'? '#3f474f' : '#1f252a' }"
      >

      </div>
    </div>
    <!--右侧 公告-->
    <div class="right-bar"></div>

    <!--第一次进入网站进行游戏选择-->
    <el-dialog
        title="选择游戏"
        :visible="gameSelectVisible"
        :close-on-click-modal="false"
        :width="'30%'">
      <div class="out-parent">
        <div class="share-item" @click="clickGameOption('val')">
          <!--          <span class="demonstration">无畏契约</span>-->
          <el-image :src="config.game.val.logoSrc"
                    style="width: 100%"
          >
          </el-image>
        </div>
        <div class="share-item" @click="clickGameOption('cs2')">
          <!--          <span class="demonstration">CS2</span>-->
          <el-image :src="config.game.cs2.logoSrc"
                    style="width: 100%"
          ></el-image>
        </div>
        <div class="share-item" @click="clickGameOption('df')">
          <!--          <span class="demonstration">CS2</span>-->
          <el-image :src="config.game.df.logoSrc"
                    style="width: 100%"
          ></el-image>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
      </span>

    </el-dialog>
    <!--无畏契约地图选项-->
    <el-dialog
        title="选择地图"
        :visible.sync="mapOptionsVisible"
        :width="'40%'"
        top="50px"
    >
      <div class="map-options">
        <template v-for="(value, name, index) in config.game.val.maps">
          <template v-if="agentToMap[userSelect.val.agent] && agentToMap[userSelect.val.agent][name]">
            <el-badge :value="agentToMap[userSelect.val.agent][name]['count']" :key="index" class="agent-badge-item">
              <div class="map-item" @click="clickMapOption(name)">
                <img :src="value.imgSrc" alt="">
                <div class="map-title">
                  <div>{{ value.title }}</div>
                  <div>{{ value.chTitle }}</div>
                </div>
              </div>
            </el-badge>
          </template>
          <template v-else>
            <el-badge :key="index" class="agent-badge-item">
              <div class="map-item" :key="index" @click="clickMapOption(name)">
                <img :src="value.imgSrc" alt="">
                <div class="map-title">
                  <div>{{ value.title }}</div>
                  <div>{{ value.chTitle }}</div>
                </div>
              </div>
            </el-badge>
          </template>
        </template>
      </div>

    </el-dialog>
    <!--无畏契约英雄选项-->
    <el-dialog
        title="选择英雄"
        :visible.sync="agentOptionsVisible"
        :width="'50%'"
        top="50px"
    >
      <div class="agent-options">
        <template v-for="(value, name, index) in config.game.val.agents">
          <template v-if="mapToAgent[userSelect.val.map] && mapToAgent[userSelect.val.map][name]">
            <el-badge :value="mapToAgent[userSelect.val.map][name]['count']" class="agent-badge-item" :key="index">
              <div class="agent-item" :style="value.background" @click="clickAgentOption(name)">
                <img :src="value.imgSrc" alt="">
                <div class="agent-title">{{ value.chTitle }}</div>
              </div>
            </el-badge>
          </template>
          <template v-else>
            <el-badge class="agent-badge-item" :key="index">
              <div class="agent-item" :style="value.background" @click="clickAgentOption(name)">
                <img :src="value.imgSrc" alt="">
                <div class="agent-title">{{ value.chTitle }}</div>
              </div>
            </el-badge>
          </template>

        </template>
      </div>

    </el-dialog>
    <!--CS2地图选项-->
    <el-dialog
        title="选择地图"
        :visible.sync="mapCS2OptionsVisible"
        :width="'40%'">
      <div class="map-options">
        <template v-for="(value, name, index) in config.game.cs2.maps">
          <template v-if="cs2MapToAbility[name]">
            <el-badge :value="cs2MapToAbility[name]['count']" :key="index" class="agent-badge-item">
              <div class="map-item" :key="index" @click="clickCS2MapOption(name)">
                <img :src="value.imgSrc" alt="">
                <div class="map-title">
                  <div>{{ value.title }}</div>
                  <div>{{ value.chTitle }}</div>
                </div>
              </div>
            </el-badge>
          </template>
          <template v-else>
            <div class="map-item" :key="index" @click="clickCS2MapOption(name)">
              <img :src="value.imgSrc" alt="">
              <div class="map-title">
                <div>{{ value.title }}</div>
                <div>{{ value.chTitle }}</div>
              </div>
            </div>
          </template>
        </template>
      </div>
    </el-dialog>
    <!--三角洲地图选项-->
    <el-dialog
        title="选择地图"
        :visible.sync="mapDFOptionsVisible"
        :width="'40%'"
        top="50px"
    >
      <div class="map-options">
        <template v-for="(value, name, index) in config.game.df.maps">
          <el-badge :key="index" class="agent-badge-item">
            <div class="map-item" :key="index" @click="clickDFMapOption(name)">
              <img :src="value.imgSrc" alt="">
              <div class="map-title">
                <div>{{ value.chTitle }}</div>
              </div>
            </div>
          </el-badge>
        </template>
      </div>

    </el-dialog>
    <!--三角洲英雄选项-->
    <el-dialog
        title="选择英雄"
        :visible.sync="agentDFOptionsVisible"
        :width="'50%'"
        top="50px"
    >
      <div class="agent-options">
        <template v-for="(value, name, index) in config.game.df.agents">
          <el-badge class="agent-badge-item" :key="index">
            <div class="agent-item" @click="clickDFAgentOption(name)">
              <img :src="value.imgSrc" alt="">
              <div class="agent-title">{{ value.chTitle }}</div>
            </div>
          </el-badge>
        </template>
      </div>

    </el-dialog>
    <!--图片预览悬浮框-->
    <div id="image-preview" class="preview" aria-hidden="true">
      <img id="image-preview-img" src="" alt="预览图"/>
      <div class="video-box" id="video-box">
        <video
            id="preview-video"
            ref="testVideo"
            src=""
            autoplay
            loop
            muted
            playsinline
            webkit-playsinline
            preload="auto"
            @loadstart="onLoadStart"
            @loadeddata="onLoadedData"
            @error="onError"
            @play="onPlay"
        ></video>
      </div>
      <div class="caption" id="image-preview-text"></div>
    </div>
    <!--具体教学的预览框-->
    <el-dialog
        :title="detailTitle"
        :visible.sync="detailDialogVisible"
        width="90%"
        top="20px"
        :close-on-click-modal="true"
        :show-close="true"
        :footer="false"
    >
      <!-- 自定义标题栏：标题 + B站原地址链接 -->
      <template slot="title">
        <div>
          <strong style="font-size: 120%; margin-right: 20px">{{ detailTitle }}</strong>
          <template v-if="videoSrc">
            查看原视频：<a :href="linkWithSecond" target="_blank">{{ linkWithSecond }}</a>
          </template>
        </div>
      </template>
      <!-- 内容区域 -->
      <div class="dialog-content">
        <!-- 只有视频的情况 -->
        <div v-if="!imageList.length" class="video-only-container">
          <iframe
              :src="videoSrc"
              scrolling="no"
              border="0"
              frameborder="no"
              framespacing="0"
              allowfullscreen="true"
              class="bilibili-video"
          ></iframe>
        </div>

        <!-- 视频+图片的情况 -->
        <div v-else class="video-image-container">
          <!-- 左侧视频 -->
          <div class="video-wrapper">
            <iframe
                :src="videoSrc"
                scrolling="no"
                border="0"
                frameborder="no"
                framespacing="0"
                allowfullscreen="true"
                class="bilibili-video"
            ></iframe>
          </div>

          <!-- 右侧图片区域 -->
          <div class="images-wrapper">
            <div class="image-list">
              <div
                  v-for="(img, index) in imageList"
                  :key="index"
                  class="image-item"
              >
                <el-image
                    :src="img"
                    fit="contain"
                    class="preview-image"
                    :preview-src-list="imageList"
                    :initial-index="index"
                    center
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {config} from "@/common/gameConfig";
import store from "@/store";
import L from 'leaflet';
import axios from 'axios';
import {distance, imgNameToUrl} from "@/common/comm";
import {biliLinkToIframe} from "@/common/bili";

let map
let startPoint //站点
let endPointGroup //落点
let tempRangePolygon //暂时的范围
let tempPolylineWithEndPoint //暂时的折线
let rangePolygonList
let endCircleLayerGroup // 初始化显示所有点位
let mouseOverLayerGroup  // 鼠标移入技能图片时显示的东西
let multipleLayerGroup // 点击聚合点位时显示的东西，多个直线连接至多个人物站位
let agentCircleMouseOverGroup //点击聚合点位后，鼠标移入不同站位时显示的直线
export default {
  name: "New",
  data() {
    return {
      config, // 各个游戏的参数配置，图片链接等等
      gameSelectVisible: false, // 显示游戏选择框，先默认为true
      userSelect: {
        val: {
          map: 'haven',
          agent: 'sova',
          ability: 4,
          side: 0,
        },
        cs2: {
          map: 'dust2',
          agent: '',
          side: 0,
          ability: 1,
        },
        df: {
          map: 'htjd',
          agent: 'luna',
        }
      },
      //地图选择的对话框是否显示
      mapOptionsVisible: false,
      agentOptionsVisible: false,
      mapCS2OptionsVisible: false,
      mapDFOptionsVisible: false,
      agentDFOptionsVisible: false,
      // 正在进行地图选点
      isSelectPointing: false,
      // 展示各个地图，各个英雄，各个技能的数量
      mapToAgent: {},
      agentToMap: {},
      cs2MapToAbility: {},
      // 展示lineup内容
      detail: {},
      detailDialogVisible: false,
      detailTitle: '',
      videoSrc: '', //B站视频嵌入地址（替换为实际地址）
      linkWithSecond: '',
      imageList: [], // 图片列表

      lineupForm: {
        blogId: null,
        title: '',
        startPoint: null,
        endPoint: null,
        //添加一个范围 sova的箭，fade的眼
        isTempPolygon: false,
        tempPolygonList: [],
        polygonList: [],
        // 添加一条折线，此折线会直接显示并且以endPoint为起点， cypher的拌线，viper的墙
        isTempPolylineWithEndPoint: false,
        polylineWithEndPointList: [],
        //额外的折线组 viper烟墙可能穿过传送门，比较特殊，暂时不能从地图直接添加，可在数据库修改数据
        isTempExtraPolylineList: false,
        tempExtraPolylineList: [],
        extraPolylineList: [],
      },
    }
  },
  computed: {
    currentPage() {
      return this.$store.state.currentPage
    }
  },
  watch: {
    currentPage: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.initMap()
          this.selectChange()
        }
      },
    }
  },
  mounted() {
    if (localStorage.getItem('currentPage')) { // 已经选择过游戏了
      this.gameSelectVisible = false
      store.commit('setCurrentPage', localStorage.getItem('currentPage'))
    } else { // 从未访问过网站
      this.gameSelectVisible = true
    }
    //读取之前用户的选择
    const savedUserSelectString = localStorage.getItem('userSelect')
    if (savedUserSelectString) {
      const savedUserSelect = JSON.parse(savedUserSelectString)
      for (let i in savedUserSelect) {
        for (let j in savedUserSelect[i]) {
          this.userSelect[i][j] = savedUserSelect[i][j]
        }
      }
      this.userSelect.val.side = 0
    }
    this.initMap()
    this.selectChange()
    this.getLineupCount()
    this.handleSetLineup() // 添加新的lineup时处理url参数
  },
  methods: {
    clickGameOption(game) { // 用户第一次进入网站时，弹出对话框进行游戏的选择
      store.commit('setCurrentPage', game)
      localStorage.setItem('currentPage', game)
      this.gameSelectVisible = false
      this.initMap()
      this.selectChange()
    },
    initMap() { // 初始化地图
      if (map) {
        map.remove()
      }
      const pngHeight = 2000
      const mapDivHeight = this.$refs.map.offsetHeight
      const mapDivWidth = this.$refs.map.offsetWidth
      let mapZoom
      if (mapDivHeight > mapDivWidth) {
        mapZoom = Math.log2(mapDivWidth / pngHeight)
      } else {
        mapZoom = Math.log2(mapDivHeight * 0.95 / pngHeight)
      }
      map = L.map('map', {
        crs: L.CRS.Simple,
        zoom: mapZoom,
        zoomSnap: 0.1,
        attributionControl: false,
      });
      // 窗格用于控制地图上图层顺序
      map.createPane('labels')
      map.getPane('labels').style.zIndex = 650
      let bounds = [[0, 0], [2000, 2000]]
      const selectMap = this.userSelect[this.currentPage].map
      L.imageOverlay(config.game[this.currentPage].maps[selectMap].radarImgSrc, bounds).addTo(map)
      map.fitBounds(bounds);
      map.setView([1000, 1000], mapZoom)
    },
    selectChange() { // 用户切换选择（地图/英雄等等）
      const _this = this;
      this.cancelRequest();
      axios({
        method: 'get',
        url: '/api/blogs/get_lineup_list',
        params: {
          game: this.currentPage,
          userSelect: this.userSelect,
        },
        cancelToken: new axios.CancelToken(function executor(c) {
          _this.source = c
        })
      }).then(r => {
        if (r.data.code === 0) {
          this.initLineup(r.data.list)
        }
      })
    },
    initLineup(dataArr) {
      let _this = this
      if (endCircleLayerGroup) {
        endCircleLayerGroup.remove()
      }
      if (multipleLayerGroup) {
        multipleLayerGroup.remove()
      }
      //把落点在一起的聚合起来，比如很多个位置都可以仍xbox烟，那么把这些xbox烟全部聚合起来
      let togetherList = []
      for (let i = 0; i < dataArr.length; i++) {
        if (!dataArr[i]) {
          continue
        }

        let lineupObj = dataArr[i]
        let endX = lineupObj.leaflet_params.endPoint[0]
        let endY = lineupObj.leaflet_params.endPoint[1]
        let togetherObj = {
          count: 1,
          endX: endX,
          endY: endY,
          list: [lineupObj],
          agent: lineupObj.agent_name,
          ability: lineupObj.ability,
        }
        for (let j = i + 1; j < dataArr.length; j++) {
          if (!dataArr[j]) {
            continue
          }
          let tmpObj = dataArr[j]
          let tmpEndX = tmpObj.leaflet_params.endPoint[0]
          let tmpEndY = tmpObj.leaflet_params.endPoint[1]
          if (distance(dataArr[i], dataArr[j]) < config.game.val.leaflet.showLineup.togetherDistance) {
            togetherObj.count += 1
            togetherObj.endX = (togetherObj.endX + tmpEndX) / 2
            togetherObj.endY = (togetherObj.endY + tmpEndY) / 2
            togetherObj.list.push(dataArr[j])
            dataArr[j] = null
          }
        }
        togetherList.push(togetherObj)
      }


      let arr = []
      for (let i = 0; i < togetherList.length; i++) {
        let togetherObj = togetherList[i]
        //技能图片
        const endX = togetherObj.endX
        const endY = togetherObj.endY
        let imgSize = config.game[_this.currentPage].leaflet.showLineup.abilityImgSize
        let agent = togetherObj.agent
        let ability = togetherObj.ability
        let pngBounds = [[endX - imgSize / 2, endY - imgSize / 2], [endX + imgSize / 2, endY + imgSize / 2]]
        let png
        if (_this.currentPage === 'val') { //无畏契约的技能图片
          png = L.imageOverlay(config.game.val.agents[agent].ability[ability].imgSrc, pngBounds, {
            zIndex: 401,
            interactive: true,
            lineupList: togetherObj.list,
            togetherObj: togetherObj
          })
        } else { // CS2技能图片（烟火雷闪）
          png = L.imageOverlay(config.game.cs2.ability[ability].imgSrc, pngBounds, {
            zIndex: 401,
            interactive: true,
            lineupList: togetherObj.list,
            togetherObj: togetherObj
          })
        }

        png.on('mouseover', endCircleMouseOver)
        png.on('mouseout', endCircleMouseOut)
        png.on('click', endCircleClick)
        png.on('mousemove', endCircleMouseMove)
        arr.push(png)
        // 技能圆形底色
        let endCircle = L.circle([endX, endY], {
          radius: config.game[_this.currentPage].leaflet.showLineup.endCircle.radius,
          fillColor: config.game[_this.currentPage].leaflet.showLineup.endCircle.fillColor,
          fillOpacity: config.game[_this.currentPage].leaflet.showLineup.endCircle.fillOpacity,
          weight: config.game[_this.currentPage].leaflet.showLineup.endCircle.weight,
          lineupList: togetherObj.list,
          togetherObj: togetherObj
        })
        endCircle.on('mouseover', endCircleMouseOver)
        endCircle.on('mouseout', endCircleMouseOut)
        endCircle.on('click', endCircleClick)
        endCircle.on('mousemove', endCircleMouseMove)
        arr.push(endCircle)
        // 直接显示的折线 viper烟墙 零的拌线, 这里有个问题，如果两个落点相同怎么处理, 目前直接显示第一个
        let firstLineupObj = togetherObj.list[0]
        if (firstLineupObj.leaflet_params.polylineWithEndPointList) {
          let tmpList = [firstLineupObj.leaflet_params.endPoint].concat(firstLineupObj.leaflet_params.polylineWithEndPointList)
          let polylineWithEndPoint = L.polyline(tmpList, {
            color: config.game.val.leaflet.showLineup.polylineWithEndPoint.color,
            weight: config.game.val.leaflet.showLineup.polylineWithEndPoint.weight
          })
          arr.push(polylineWithEndPoint)
        }
        // 额外的折线组，viper烟墙通过传送门时的情况
        if (firstLineupObj.leaflet_params.extraPolylineList) {
          let extraPolylineList = firstLineupObj.leaflet_params.extraPolylineList
          for (let i = 0; i < extraPolylineList.length; i++) {
            let polyline = L.polyline(extraPolylineList[i], {
              color: config.game.val.leaflet.showLineup.polylineWithEndPoint.color,
              weight: config.game.val.leaflet.showLineup.polylineWithEndPoint.weight
            })
            arr.push(polyline)
          }
        }

      }
      endCircleLayerGroup = L.layerGroup(arr)
      endCircleLayerGroup.addTo(map)


      // 鼠标移入技能图片事件
      function endCircleMouseOver(e) {
        // alert('移入')
        let arr = []
        // 在技能图片出显示一个圈
        let endX = e.sourceTarget.options.togetherObj.endX
        let endY = e.sourceTarget.options.togetherObj.endY
        let circle = L.circle([endX, endY], {
          radius: config.game[_this.currentPage].leaflet.showLineup.endCircleMouseOver.radius,
          color: config.game[_this.currentPage].leaflet.showLineup.endCircleMouseOver.color,
          weight: config.game[_this.currentPage].leaflet.showLineup.endCircleMouseOver.weight,
        })
        arr.push(circle)

        let lineupList = e.sourceTarget.options.lineupList
        // 单个lineup，不是多个站位聚合的，显示名称
        if (lineupList.length === 1) {
          let currentUrl = lineupList[0].start_image
          previewText.textContent = lineupList[0].lineup_title
          showPreview(currentUrl, lineupList[0].leaflet_params.cutVideo);
        }
        for (let i = 0; i < lineupList.length; i++) {
          let lineupObj = lineupList[i]
          //显示人物站点
          if (lineupObj.leaflet_params.startPoint) {
            let startX = lineupObj.leaflet_params.startPoint[0]
            let startY = lineupObj.leaflet_params.startPoint[1]
            //显示起始点的一条直线，
            // eslint-disable-next-line no-empty
            if (lineupObj.ability === 2 && lineupObj.agent_name === 'neon') {
              //霓虹的震不显示
            } else {
              let startEndLine = L.polyline([[startX, startY], [endX, endY]], {
                color: config.game.val.leaflet.showLineup.startEndLine.color,
                weight: config.game.val.leaflet.showLineup.startEndLine.weight,
              });
              arr.push(startEndLine)
            }

            // 无畏契约显示人物图片和背景色
            if (_this.currentPage === 'val') {
              let imgSize = config.game.val.leaflet.showLineup.agentImgSize
              let agent = lineupObj.agent_name
              let pngBounds = [[startX - imgSize / 2, startY - imgSize / 2], [startX + imgSize / 2, startY + imgSize / 2]]
              let agentPng = L.imageOverlay(config.game.val.agents[agent].imgSrc, pngBounds, {
                zIndex: 401,
                interactive: true,
              })
              arr.push(agentPng)
              //人物背景
              let agentCircle = L.circle([startX, startY], {
                radius: config.game.val.leaflet.showLineup.agentCircle.radius,
                weight: config.game.val.leaflet.showLineup.agentCircle.weight,
                fillOpacity: config.game.val.leaflet.showLineup.agentCircle.fillOpacity,
                fillColor: config.game.val.agents[agent].color
              })
              arr.push(agentCircle)
            } else { // CS2
              if (lineupObj.start_image === '') {
                //没有站位图片，常规位置，绘制圆圈站点
                let agentCircle = L.circle([startX, startY], {
                  radius: config.game.cs2.leaflet.showLineup.agentCircle.radius,
                  weight: config.game.cs2.leaflet.showLineup.agentCircle.weight,
                  fillOpacity: config.game.cs2.leaflet.showLineup.agentCircle.fillOpacity,
                  fillColor: config.game.cs2.leaflet.showLineup.agentCircle.fillColor,
                  color: config.game.cs2.leaflet.showLineup.agentCircle.color,
                  pane: 'labels'
                })
                arr.push(agentCircle)
              } else {
                // 有站位图片，一般是出生位快烟，绘制绿色正方形站点
                let sideLength = 40
                var bounds = [[startX - sideLength / 2, startY - sideLength / 2], [startX + sideLength / 2, startY + sideLength / 2]]
                let rectangle = L.rectangle(bounds, {
                  color: config.game.cs2.leaflet.showLineup.agentRectangle.color,
                  weight: config.game.cs2.leaflet.showLineup.agentRectangle.weight,
                  pane: 'labels'
                })
                arr.push(rectangle)
              }
            }
          }
        }
        //mouseover组显示
        mouseOverLayerGroup = L.layerGroup(arr)
        mouseOverLayerGroup.addTo(map)
      }

      // 鼠标移出技能图片事件
      function endCircleMouseOut() {
        if (mouseOverLayerGroup) {
          mouseOverLayerGroup.remove()
        }
        // 隐藏图片悬浮DIV
        hidePreview();
      }

      // 鼠标在圆圈上移动时显示名称
      function endCircleMouseMove(e) {
        positionPreview(e.originalEvent.pageX, e.originalEvent.pageY);
      }

      //鼠标点击技能图片事件
      function endCircleClick(e) {
        if (_this.isSelectPointing) {
          //如果正在地图选点，不触发点击事件
          return
        }
        if (multipleLayerGroup) { // 有可能前面点击过，之前显示的多条直线和站位移除
          multipleLayerGroup.remove()
        }
        if (agentCircleMouseOverGroup) {
          agentCircleMouseOverGroup.remove()
        }
        // 隐藏悬浮文字和图片
        hidePreview()

        let lineupList = e.sourceTarget.options.lineupList
        if (lineupList.length === 1) { // 只有一个道具，打开具体教学页面
          let lineupObj = lineupList[0]
          // window.open('/discuss/' + lineupObj.blog_id)
          _this.getLineupDetail(lineupObj.blog_id)
        } else { // 很多个不同站位，相同落点的道具
          let arr = []
          _this.$message('多个站位，点击站位查看对应教学');
          //落点显示一个圈
          let endX = e.sourceTarget.options.togetherObj.endX
          let endY = e.sourceTarget.options.togetherObj.endY
          let circle = L.circle([endX, endY], {
            radius: config.game[_this.currentPage].leaflet.showLineup.endCircleMouseOver.radius,
            color: config.game[_this.currentPage].leaflet.showLineup.endCircleMouseOver.color,
            weight: config.game[_this.currentPage].leaflet.showLineup.endCircleMouseOver.weight,
          })
          arr.push(circle)
          //遍历所有的不同站位
          for (let i = 0; i < lineupList.length; i++) {
            let lineupObj = lineupList[i]
            let startX = lineupObj.leaflet_params.startPoint[0]
            let startY = lineupObj.leaflet_params.startPoint[1]
            let endX = lineupObj.leaflet_params.endPoint[0]
            let endY = lineupObj.leaflet_params.endPoint[1]
            //显示起始点的一条直线
            let startEndLine = L.polyline([[startX, startY], [endX, endY]], {
              color: config.game[_this.currentPage].leaflet.showLineup.startEndLine.color,
              weight: config.game[_this.currentPage].leaflet.showLineup.startEndLine.weight,
            });
            arr.push(startEndLine)
            //无畏契约显示人物图片
            if (_this.currentPage === 'val') {
              let imgSize = config.game.val.leaflet.showLineup.agentImgSize
              let agent = lineupObj.agent_name
              let pngBounds = [[startX - imgSize / 2, startY - imgSize / 2], [startX + imgSize / 2, startY + imgSize / 2]]
              let agentPng = L.imageOverlay(config.game.val.agents[agent].imgSrc, pngBounds, {
                zIndex: 401,
                interactive: true,
                lineupList: [lineupObj],
                togetherObj: e.sourceTarget.options.togetherObj,
              })
              agentPng.on('mouseover', agentCircleMouseOver)
              agentPng.on('mouseout', agentCircleMouseOut)
              agentPng.on('click', endCircleClick)
              agentPng.on('mousemove', agentCircleMouseMove)
              arr.push(agentPng)
              //人物背景
              let agentCircle = L.circle([startX, startY], {
                radius: config.game[_this.currentPage].leaflet.showLineup.agentCircle.radius,
                weight: config.game[_this.currentPage].leaflet.showLineup.agentCircle.weight,
                fillOpacity: config.game[_this.currentPage].leaflet.showLineup.agentCircle.fillOpacity,
                fillColor: config.game[_this.currentPage].agents[agent].color,
                togetherObj: e.sourceTarget.options.togetherObj,
                lineupList: [lineupObj]
              })
              agentCircle.on('mouseover', agentCircleMouseOver)
              agentCircle.on('mouseout', agentCircleMouseOut)
              agentCircle.on('click', endCircleClick)
              agentCircle.on('mousemove', agentCircleMouseMove)
              arr.push(agentCircle)
            } else { // CS2
              let agentCircle
              if (lineupObj.start_image === '') {
                //没有站位图片，常规位置，绘制圆圈站点
                agentCircle = L.circle([startX, startY], {
                  radius: config.game[_this.currentPage].leaflet.showLineup.agentCircle.radius,
                  weight: config.game[_this.currentPage].leaflet.showLineup.agentCircle.weight,
                  fillOpacity: config.game[_this.currentPage].leaflet.showLineup.agentCircle.fillOpacity,
                  fillColor: config.game[_this.currentPage].leaflet.showLineup.agentCircle.fillColor,
                  color: config.game[_this.currentPage].leaflet.showLineup.agentCircle.color,
                  lineupList: [lineupObj],
                  togetherObj: e.sourceTarget.options.togetherObj,
                  pane: 'labels'
                })
              } else {
                //有站位图片，一般是出生位快烟，绘制绿色正方形站点
                let sideLength = 40
                var bounds = [[startX - sideLength / 2, startY - sideLength / 2], [startX + sideLength / 2, startY + sideLength / 2]]
                agentCircle = L.rectangle(bounds, {
                  color: config.game[_this.currentPage].leaflet.showLineup.agentRectangle.color,
                  weight: config.game[_this.currentPage].leaflet.showLineup.agentRectangle.weight,
                  lineupList: [lineupObj],
                  togetherObj: e.sourceTarget.options.togetherObj,
                  pane: 'labels'
                })
              }
              agentCircle.on('mouseover', agentCircleMouseOver)
              agentCircle.on('mouseout', agentCircleMouseOut)
              agentCircle.on('mousemove', agentCircleMouseMove)
              agentCircle.on('click', endCircleClick)
              arr.push(agentCircle)
            }
          }

          multipleLayerGroup = L.layerGroup(arr)
          multipleLayerGroup.addTo(map)
        }
      }

      // 相同落点的道具点击之后，会显示所有不同的站位起点，鼠标移入站点时的事件
      function agentCircleMouseOver(e) {
        let arr = []
        let lineupList = e.sourceTarget.options.lineupList
        if (lineupList.length === 1) {
          let togetherObj = e.sourceTarget.options.togetherObj
          let lineupObj = lineupList[0]
          // 站点圆圈变化
          if (_this.currentPage === 'cs2') { // CS2 改变圆圈style
            if (lineupObj.start_image === '') {
              e.target.setStyle(config.game[_this.currentPage].leaflet.showLineup.agentCircleMouseOver);
              e.target.setRadius(config.game[_this.currentPage].leaflet.showLineup.agentCircleMouseOver.radius)
            } else {
              e.target.setStyle(config.game[_this.currentPage].leaflet.showLineup.agentRectangleMouseOver);
            }
          } else { //无畏契约 画一个新的圆圈
            let circle = L.circle([lineupObj.leaflet_params.startPoint[0], lineupObj.leaflet_params.startPoint[1]], {
              radius: config.game[_this.currentPage].leaflet.showLineup.endCircleMouseOver.radius,
              color: '#ffcc00',
              weight: config.game[_this.currentPage].leaflet.showLineup.endCircleMouseOver.weight,
            })
            arr.push(circle)
          }

          // 起点落点之间绘制一条新的加粗的线
          let startEndLine = L.polyline([[lineupObj.leaflet_params.startPoint[0], lineupObj.leaflet_params.startPoint[1]], [togetherObj.endX, togetherObj.endY]],
              config.game[_this.currentPage].leaflet.showLineup.startEndLineMouseOver
          );
          arr.push(startEndLine)
          agentCircleMouseOverGroup = L.layerGroup(arr)
          agentCircleMouseOverGroup.addTo(map)
          // 显示图片悬浮DIV
          let currentUrl = lineupObj.start_image
          previewText.textContent = lineupObj.lineup_title
          showPreview(currentUrl, lineupObj.leaflet_params.cutVideo);
        }

      }

      function agentCircleMouseOut(e) {
        let lineupObj = e.sourceTarget.options.lineupList[0]
        if (_this.currentPage === 'cs2') {
          if (lineupObj.start_image === '') {
            e.target.setStyle(config.game.cs2.leaflet.showLineup.agentCircle);
            e.target.setRadius(config.game.cs2.leaflet.showLineup.agentCircle.radius)
          } else {
            e.target.setStyle(config.game.cs2.leaflet.showLineup.agentRectangle);
          }
        }
        if (agentCircleMouseOverGroup) {
          agentCircleMouseOverGroup.remove()
        }
        // 隐藏图片悬浮DIV
        hidePreview();

      }

      function agentCircleMouseMove(e) {
        positionPreview(e.originalEvent.pageX, e.originalEvent.pageY);
      }

      const OFFSET_X = 14
      const OFFSET_Y = 14
      const preview = document.getElementById('image-preview');
      const previewImg = document.getElementById('image-preview-img');
      const previewText = document.getElementById('image-preview-text');
      const previewVideo = document.getElementById('preview-video');
      const previewVideoBox = document.getElementById('video-box');

      function showPreview(imgName, cutVideo) {
        previewImg.src = ''
        preview.classList.add('show');
        preview.setAttribute('aria-hidden', 'false');
        if (imgName) {
          previewImg.src = 'https://img.lkval.com/static/start-image/' + imgName;
          previewImg.style.display = "block";
        } else {
          previewImg.style.display = "none";
        }
        if (cutVideo) {
          previewVideo.src = 'https://img.lkval.com/userupload/' + cutVideo;
          previewVideoBox.style.display = "block"
        } else {
          previewVideoBox.style.display = "None"
        }
      }

      function hidePreview() {
        preview.classList.remove('show');
        preview.setAttribute('aria-hidden', 'true');
        // 可选：延迟清空 src 避免频繁重新加载（按需）
        // previewImg.src = '';
      }

      function positionPreview(clientX, clientY) {
        // 基本位置在鼠标偏移处
        let left = clientX + OFFSET_X;
        let top = clientY + OFFSET_Y;

        // 边界检测：若靠近右/下边缘，则把预览移到左/上侧
        const padding = 8;
        const rect = preview.getBoundingClientRect();
        const vw = document.documentElement.clientWidth;
        const vh = document.documentElement.clientHeight;

        // 如果超出右边界
        if (left + rect.width + padding > vw) {
          left = clientX - rect.width - OFFSET_X;
        }
        // 如果超出下边界
        if (top + rect.height + padding > vh) {
          top = clientY - rect.height - OFFSET_Y;
        }

        // 最终应用
        preview.style.left = left + 'px';
        preview.style.top = top + 'px';
      }
    },

    cancelRequest() {
      if (typeof this.source === 'function') {
        this.source('终止请求')
      }
    },
    showMapOptions() {
      this.mapOptionsVisible = true
    },
    showAgentOptions() {
      this.agentOptionsVisible = true
    },
    clickAbilityOption(name) { // 无畏契约点击技能
      this.userSelect.val.ability = name
      localStorage.setItem('userSelect', JSON.stringify(this.userSelect))
      this.selectChange()
    },
    clickSideOption(side) { // 无畏契约点击 防守/进攻
      if (side !== this.userSelect.val.side) {
        this.userSelect.val.side = side
        localStorage.setItem('userSelect', JSON.stringify(this.userSelect))
        this.selectChange()
      }
    },
    clickMapOption(name) {
      this.userSelect.val.map = name
      localStorage.setItem('userSelect', JSON.stringify(this.userSelect))
      this.mapOptionsVisible = false
      this.initMap()
      this.selectChange()
    },
    clickAgentOption(name) {
      this.userSelect.val.agent = name
      this.agentOptionsVisible = false
      localStorage.setItem('userSelect', JSON.stringify(this.userSelect))
      this.selectChange()
    },
    getLineupCount() { // 获取每张地图 每个英雄的lineup个数
      axios({
        method: 'get',
        url: '/api/blogs/get_lineup_count',
      }).then(r => {
        if (r.data.code === 0) {
          this.agentToMap = r.data.agent_to_map
          this.mapToAgent = r.data.map_to_agent
          this.cs2MapToAbility = r.data.cs2_map_to_ability
          for (let i in this.agentToMap) {
            for (let j in this.agentToMap[i]) {
              let count = 0
              for (let k in this.agentToMap[i][j]) {
                count += this.agentToMap[i][j][k]
              }
              this.agentToMap[i][j]['count'] = count
            }
          }
          for (let i in this.mapToAgent) {
            for (let j in this.mapToAgent[i]) {
              let count = 0
              for (let k in this.mapToAgent[i][j]) {
                count += this.mapToAgent[i][j][k]
              }
              this.mapToAgent[i][j]['count'] = count
            }
          }
          for (let i in this.cs2MapToAbility) {
            let count = 0
            for (let j in this.cs2MapToAbility[i]) {
              count += this.cs2MapToAbility[i][j]
            }
            this.cs2MapToAbility[i]['count'] = count
          }
        }
      })
    },
    changeSideOptions(side) { // CS2 选择进攻防守
      if (side !== this.selectSide) {
        this.selectSide = side
        localStorage.setItem('userSelect', JSON.stringify(this.userSelect))
        this.selectChange()
      }
    },
    clickCS2AbilityOption(name) {
      this.userSelect.cs2.ability = name
      localStorage.setItem('userSelect', JSON.stringify(this.userSelect))
      this.selectChange()
    },
    changeCS2SideOptions(side) {
      if (side !== this.userSelect.cs2.side) {
        this.userSelect.cs2.side = side
        localStorage.setItem('userSelect', JSON.stringify(this.userSelect))
        this.selectChange()
      }
    },
    showCS2MapOptions() {
      this.mapCS2OptionsVisible = true
    },
    clickCS2MapOption(name) {
      this.userSelect.cs2.map = name
      localStorage.setItem('userSelect', JSON.stringify(this.userSelect))
      this.mapCS2OptionsVisible = false
      this.initMap()
      this.selectChange()
    },
    getLineupDetail(blogId) {
      axios({
        method: 'get',
        url: '/api/blogs/get_lineup_detail',
        params: {
          blog_id: blogId
        }
      }).then(r => {
        if (r.data.code !== 0) {
          this.$message.error(r.data.msg);
        } else {
          this.detailDialogVisible = true
          this.detail = {}
          this.detailTitle = ''
          this.imageList = []
          this.videoSrc = ''
          this.linkWithSecond = ''
          this.detail = r.data.detail
          this.detailTitle = this.detail.title
          // 处理视频
          if (this.detail.bili_link) {
            const [videoSrc, linkWithSecond] = biliLinkToIframe(this.detail.bili_link, this.detail.bili_start_minute, this.detail.bili_start_second, this.detail.bili_iframe)
            this.videoSrc = videoSrc
            this.linkWithSecond = linkWithSecond
          }
          // 处理图片
          for (let i = 0; i < this.detail.images.length; i++) {
            this.imageList.push(imgNameToUrl(this.detail.images[i]))
          }
        }
      })
    },
    selectPoint(type) {
      if (type === 'start') {
        this.$message({
          message: '点击地图位置，选择人物站点',
          duration: 2000,
        })
      } else {
        this.$message({
          message: '点击地图位置，选择道具落点',
          duration: 2000,
        })
      }
      let _this = this
      this.isSelectPointing = true
      map.on('click', function (e) {
        alert(e.latlng)
        const x = Math.round(e.latlng.lat)
        const y = Math.round(e.latlng.lng)
        if (type === 'start') { // 选择站点
          if (startPoint) {
            startPoint.remove()
          }
          startPoint = L.circle([x, y], {
            radius: config.game[_this.currentPage].leaflet.addLineup.point.radius,
            fillColor: config.game[_this.currentPage].leaflet.addLineup.point.startPointFillColor,
            weight: 0,
            fillOpacity: 1,
          }).addTo(map);
          _this.lineupForm.startPoint = [x, y]
        } else { //选择落点
          if (endPointGroup) {
            endPointGroup.remove()
          }
          let arr = []
          let endPoint = L.circle([x, y], {
            radius: config.game[_this.currentPage].leaflet.addLineup.point.radius,
            fillColor: config.game[_this.currentPage].leaflet.addLineup.point.endPointFillColor,
            weight: 0,
            fillOpacity: 1,
          })
          _this.lineupForm.endPoint = [x, y]
          arr.push(endPoint)

          //技能图片
          let imgSize = config.game[_this.currentPage].leaflet.showLineup.abilityImgSize
          let pngBounds = [[x - imgSize / 2, y - imgSize / 2], [x + imgSize / 2, y + imgSize / 2]]
          let png
          if (_this.currentPage === 'val') {
            let selectAgent = _this.userSelect.val.agent
            let selectAbility = _this.userSelect.val.ability
            png = L.imageOverlay(config.game.val.agents[selectAgent].ability[selectAbility].imgSrc, pngBounds, {
              zIndex: 401,
              interactive: true,
            })
          } else {
            let selectAbility = _this.userSelect.cs2.ability
            png = L.imageOverlay(config.game.cs2.ability[selectAbility].imgSrc, pngBounds, {
              zIndex: 401,
              interactive: true,
            })
          }
          arr.push(png)

          //技能透明圆圈
          let endCircle = L.circle([x, y], {
            radius: config.game[_this.currentPage].leaflet.showLineup.endCircle.radius,
            fillColor: config.game[_this.currentPage].leaflet.showLineup.endCircle.fillColor,
            fillOpacity: config.game[_this.currentPage].leaflet.showLineup.endCircle.fillOpacity,
            weight: config.game[_this.currentPage].leaflet.showLineup.endCircle.weight,

          })
          arr.push(endCircle)
          endPointGroup = L.layerGroup(arr)
          endPointGroup.addTo(map)
        }


        map.off('click')
        this.isSelectPointing = false
      });
    },
    selectRangeDone() {
      this.lineupForm.polygonList.push(this.lineupForm.tempPolygonList)
      this.showPolygonList()
      map.off('click')
      this.lineupForm.tempPolygonList = []
      this.lineupForm.isTempPolygon = false
      if (tempRangePolygon) {
        tempRangePolygon.remove()
      }
    },
    selectRange() {
      let _this = this
      this.lineupForm.isTempPolygon = true
      this.lineupForm.tempPolygonList = []
      map.on('click', function (e) {
        const x = Math.round(e.latlng.lat)
        const y = Math.round(e.latlng.lng)
        _this.lineupForm.tempPolygonList.push([x, y])
        if (tempRangePolygon) {
          tempRangePolygon.remove()
        }
        tempRangePolygon = L.polygon(_this.lineupForm.tempPolygonList, {
          color: config.game.val.leaflet.addLineup.polygon.color,
          weight: config.game.val.leaflet.addLineup.polygon.weight,
        }).addTo(map)
      })
    },
    handleClosePolygon(index) {
      this.lineupForm.polygonList.splice(index, 1)
      this.showPolygonList()
    },
    showPolygonList() {
      if (rangePolygonList) {
        rangePolygonList.remove()
      }
      let arr = []
      for (let i = 0; i < this.lineupForm.polygonList.length; i++) {
        let polygon = L.polygon(this.lineupForm.polygonList[i], {
          color: config.game.val.leaflet.addLineup.polygon.color,
          weight: config.game.val.leaflet.addLineup.polygon.weight,
        })
        arr.push(polygon)
      }
      rangePolygonList = L.layerGroup(arr)
      rangePolygonList.addTo(map)
    },
    selectPolylineWithEndPointDone() {
      map.off('click')
      this.lineupForm.isTempPolylineWithEndPoint = false
    },
    selectPolylineWithEndPoint() {
      if (!this.lineupForm.endPoint) {
        this.$message.error('请先选择落点');
        return
      }
      let _this = this
      this.lineupForm.isTempPolylineWithEndPoint = true
      this.lineupForm.polylineWithEndPointList = []
      map.on('click', function (e) {
        const x = Math.round(e.latlng.lat)
        const y = Math.round(e.latlng.lng)
        _this.lineupForm.polylineWithEndPointList.push([x, y])
        if (tempPolylineWithEndPoint) {
          tempPolylineWithEndPoint.remove()
        }
        let tmpList = [_this.lineupForm.endPoint].concat(_this.lineupForm.polylineWithEndPointList)
        tempPolylineWithEndPoint = L.polyline(tmpList, {color: 'red', weight: 2}).addTo(map)
      })
    },
    handleClosePolylineWithEndPoint() {
      this.lineupForm.polylineWithEndPointList = []
      if (tempPolylineWithEndPoint) {
        tempPolylineWithEndPoint.remove()
      }
    },
    submitLineup() {
      let game
      if (this.currentPage === 'val') {
        game = 1
      } else {
        game = 2
      }
      axios({
        method: 'post',
        url: '/api/blogs/submit_lineup',
        data: Object.assign({}, this.lineupForm, {
          game: game,
          side: this.userSelect[this.currentPage].side,
          map_name: this.userSelect[this.currentPage].map,
          agent_name: this.userSelect[this.currentPage].agent,
          ability: this.userSelect[this.currentPage].ability
        })
      }).then(r => {
        if (r.data.code === 0) {
          // this.lineupForm = {
          //   blogId: null,
          //   title: '',
          //   startPoint: null,
          //   endPoint: null,
          //
          //   isTempPolygon: false,
          //   tempPolygonList: [],
          //   polygonList: [],
          //
          //   isTempPolylineWithEndPoint: false,
          //   polylineWithEndPointList: [],
          //   extraPolylineList: [],
          // }
          // this.$router.push({query: {}});
          this.selectChange()
          this.isSelectPointing = false
          this.$message({
            message: '提交成功',
            type: 'success'
          });
        } else {
          this.$message.error(r.data.msg);
        }
      })
    },
    showDFMapOptions() {
      this.mapDFOptionsVisible = true
    },
    showDFAgentOptions() {
      this.agentDFOptionsVisible = true
    },
    clickDFMapOption(name) {
      this.userSelect.df.map = name
      localStorage.setItem('userSelect', JSON.stringify(this.userSelect))
      this.mapDFOptionsVisible = false
      this.initMap()
      this.selectChange()
    },
    clickDFAgentOption(name) {
      this.userSelect.df.agent = name
      this.agentDFOptionsVisible = false
      localStorage.setItem('userSelect', JSON.stringify(this.userSelect))
      this.selectChange()
    },
    handleSetLineup() {
      if (this.$route.query.blogid) {
        this.lineupForm.blogId = this.$route.query.blogid
      }
    },
    onLoadStart() {
      this.statusMsg = '资源开始加载 (206 是正常的)';
      console.log('Event: loadstart');
    },
    onLoadedData() {
      this.statusMsg = '数据已加载，准备播放';
      console.log('Event: loadeddata - 视频首帧已就绪');
    },
    onPlay() {
      this.statusMsg = '播放中';
      console.log('Event: play');
    },
    onError(e) {
      this.errorMsg = '视频加载错误';
      console.error('Video Error Event:', e);
      console.error('Error Code:', this.$refs.testVideo.error.code);
      console.error('Error Message:', this.$refs.testVideo.error.message);

      // 常见错误码解释
      // 1: MEDIA_ERR_ABORTED
      // 2: MEDIA_ERR_NETWORK (网络中断，可能是 CORS 或 链接失效)
      // 3: MEDIA_ERR_DECODE (格式不支持，如 H.265)
      // 4: MEDIA_ERR_SRC_NOT_SUPPORTED (URL 错误或格式完全不支持)
    }
  },

}
</script>

<style scoped>
.main {
  display: flex;
  height: calc(100vh - 72px);
  background: #f1f2f5;
  justify-content: center;
}

/* ::v-deep 穿透scoped，只作用于当前类名的弹窗 */
::v-deep .el-dialog__body {
  padding: 0 0 10px 0 !important; /* !important 确保覆盖Element默认样式 */
}

.left-bar {
  width: 300px;
  padding: 10px;
}

.mid-bar {
  width: calc(100vh - 72px);
  height: calc(100vh - 72px);
  padding: 10px 0;
}

.right-bar {
  width: 300px;
  padding: 10px;
}

.out-parent {
  display: flex;
  width: 100%;
}

.share-item {
  flex: 1;
  height: 100%;
  margin-left: 2%;
  margin-right: 2%;
  display: flex;
  justify-items: center;
  align-items: center;
  cursor: pointer;
}

#map {
  height: 100%;
  background-color: #3f474f;
  border-radius: 10px;
}

.map-agent {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.map-agent .select-map {
  width: 190px;
  height: 70px;
  overflow: hidden;
  border-radius: 10px;
  cursor: pointer;
  position: relative;

}

.map-agent .select-map img {
  transition: transform 0.3s;
  width: 100%;
}

.map-agent .select-map:hover > img {
  transform: scale(1.2);
}

.map-agent .select-map .select-map-title {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: white;
  font-weight: 600;
  font-size: 20px;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
}

.map-agent .select-agent {
  width: 70px;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
}

.map-agent .select-agent .agent-title {
  position: absolute;
  bottom: 10%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: 600;
  font-size: 10px;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
}

.map-agent .select-agent img {
  width: 100%;
  transition: transform 0.3s;
}

.map-agent .select-agent:hover > img {
  transform: scale(1.2);
}

.img-opacity2 {
  opacity: 0.2;
}

.agent-options .agent-item .agent-title {
  position: absolute;
  bottom: 10%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: 600;
  font-size: 10px;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
}

.ability-options {
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  margin-bottom: -14px;
}

.ability-options .ability-item {
  width: 50px;
  height: 50px;
  background: #0f1923;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 15px;
  cursor: pointer;
  margin-bottom: 14px;
}

.ability-options .ability-item img {
  width: 35px;
  height: 35px;
}

.radio-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 15px;
}

.radio-item {
  position: relative;
  display: inline-block;
}

.radio-item input[type="radio"] {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.radio-item label {
  align-items: center;
  padding: 3px 6px;
  background-color: #f8f9fa;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  color: #333;
  transition: all 0.3s ease;
  text-align: center;
  min-width: 85px;
  user-select: none;
  gap: 4px;
}

.radio-item label:hover {
  background-color: #e9ecef;
  border-color: #007bff;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.radio-item input[type="radio"]:checked + label {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
}

.radio-item input[type="radio"]:checked + label:hover {
  background-color: #0056b3;
  border-color: #0056b3;
}

.map-options {
  display: flex;
  flex-flow: wrap;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
}

.map-options .map-item {
  width: 150px;
  margin: 3px;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  border-radius: 10px;
}

.map-options .map-item img {
  width: 100%;
  transition: transform 0.3s;
}

.map-options .map-item:hover > img {
  transform: scale(1.2);
}

.map-options .map-item .map-title {
  position: absolute;
  bottom: 10%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: white;
  font-weight: 600;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
}


.agent-options {
  margin: 10px;
  display: flex;
  flex-flow: wrap;
  /*justify-content: space-evenly;*/
  align-items: center;
}

.agent-options .agent-item {
  margin: 5px;
  width: 70px;
  height: 70px;
  position: relative;
  border-radius: 5px;
  cursor: pointer;
  overflow: hidden;
}

.agent-badge-item {
  margin: 10px;
}

.agent-options .agent-item img {
  width: 100%;
  transition: transform 0.3s;
}

.agent-options .agent-item:hover > img {
  transform: scale(1.2);
}

.cs2-map-agent {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cs2-map-agent .select-map {
  width: 100%;
  height: 90px;
  overflow: hidden;
  border-radius: 10px;
  cursor: pointer;
  position: relative;

}

.cs2-map-agent .select-map img {
  transition: transform 0.3s;
  width: 100%;
}

.cs2-map-agent .select-map:hover > img {
  transform: scale(1.2);
}


.cs2-map-agent .select-map .select-map-title {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: white;
  font-weight: 600;
  font-size: 20px;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
}

.cs2-map-agent .select-agent {
  width: 70px;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
}

.cs2-map-agent .select-agent .agent-title {
  position: absolute;
  bottom: 10%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: 600;
  font-size: 10px;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
}


.cs2-map-agent .select-agent img {
  width: 100%;
  transition: transform 0.3s;
}

.cs2-map-agent .select-agent:hover > img {
  transform: scale(1.2);
}

.cs2-radio-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 15px;
}

.cs2-radio-buttons .radio-item {
  position: relative;
  display: inline-block;
}

.cs2-radio-buttons .radio-item input[type="radio"] {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.cs2-radio-buttons .radio-item label {
  display: flex;
  align-items: center;
  padding: 3px 6px;
  background-color: #f8f9fa;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  color: #333;
  transition: all 0.3s ease;
  text-align: center;
  min-width: 85px;
  user-select: none;
  gap: 4px;
}

/* 圆形图标样式 */
.radio-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}

/* 颜色图标 */
.icon-red {
  background-color: #ffffff;
}

/* 预览图层：固定定位，pointer-events:none 避免阻挡鼠标事件 */
.preview {
  left: 0;
  top: 0;
  transform-origin: left top;
  z-index: 9999;
  /*/ / transition: opacity 120 ms ease, transform 120 ms ease;*/
  position: fixed;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.3s ease;
  max-width: 500px;
  text-align: center;
  font-size: 14px;
  color: #333;
}

.preview img {

  width: 500px; /* 图片加大，可以再调，比如 350px */
  height: auto;
  display: block;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.preview.show {
  opacity: 1;
}

.preview .caption {
  margin: 0;
  padding: 6px 10px;
  background: rgba(0, 0, 0, 0.75); /* 半透明深色背景 */
  color: #fff;
  border-radius: 6px;
}

/*!* 自定义标题容器 *!*/
/*.dialog-title-wrap {*/
/*  display: flex;*/
/*  justify-content: space-between;*/
/*  align-items: center;*/
/*  width: 100%;*/
/*}*/

/* B站原地址链接样式 */
.bilibili-link {
  color: #fb7299; /* B站主题色 */
  font-size: 14px;
  text-decoration: none;
  margin-left: 10px;
}

.bilibili-link:hover {
  color: #f6588e;
  text-decoration: underline;
}

/* 整体对话框内容样式 */
.dialog-content {
  width: 100%;
  height: 80vh;
  box-sizing: border-box;
  padding: 10px;
}

/* 只有视频的容器 */
.video-only-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 视频+图片容器 */
.video-image-container {
  width: 100%;
  height: 100%;
  display: flex;
  gap: 20px;
}

/* 视频容器 */
.video-wrapper {
  flex: 2;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* B站视频样式 */
.bilibili-video {
  width: 100%;
  height: 95%;
  min-height: 400px;
}

/* 图片容器 */
.images-wrapper {
  flex: 1;
  height: 100%;
  overflow: hidden;
}

/* 图片列表（可滚动） */
.image-list {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  overflow-y: auto;
  padding-right: 5px;
}

/* 单个图片项 */
.image-item {
  width: 100%;
  flex-shrink: 0;
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
}

.image-item:hover {
  transform: scale(1.02);
}

/* 预览图片样式 */
.preview-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

/* 滚动条样式优化 */
.image-list::-webkit-scrollbar {
  width: 6px;
}

.image-list::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 3px;
}
.video-box {
  max-width: 500px;
  aspect-ratio: 16 / 9;
  background-color: #000;
  overflow: hidden;
  position: relative;
}
video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
</style>